// Czy rezerwacja jest anulowana: jedna reguła dla wszystkich ekranów panelu.
//
// Od 2026-10-02 przycisk „Anuluj rezerwację" NIE kasuje rezerwacji, tylko nadaje jej status
// „Anulowana" (historia zostaje, sprzęt wraca do puli). Taka rezerwacja nadal przychodzi w listach
// z serwera (/api/all-reservations, /api/rentals), więc ekrany pokazujące obłożenie i liczby
// (siatka kalendarza, panel dnia, „Nadchodzące" na stronie głównej, statystyki, kalendarz sprzętu)
// muszą ją pomijać. Zakładka „Historia" w kalendarzu pokazuje ją dalej, ze statusem.
//
// To jest JEDYNA kopia reguły w panelu: `normalizeStatus` (pages/calendar/utils.js) i
// `czyAnulowana` (utils/nadchodzaceRezerwacje.js) pytają tę funkcję. Wzorzec jest lustrem
// Login/backend/lib/activeReservations.js#WZOR_ANULOWANEJ (panel nie może importować backendu);
// równość wzorca i wyników na wspólnej liście nazw pilnuje utils/__tests__/reservationStatus.test.js.
export const WZOR_ANULOWANEJ = '^(anulowan|cancel)';
const WZOR_ANULOWANEJ_RE = new RegExp(WZOR_ANULOWANEJ, 'i');

// Nazwa statusu zaczyna się od „anulowan" albo „cancel", bez względu na wielkość liter. Biały znak
// na początku NIE jest pomijany, bo serwer też go nie pomija (dawne `trim()` dawało tu inny wynik
// niż w Statystykach). Pusta nazwa, null i liczba to nie anulowana.
export function isCancelledStatusName(name) {
  return WZOR_ANULOWANEJ_RE.test(name == null ? '' : String(name));
}

// Status przychodzi pod dwiema nazwami pól zależnie od trasy. `reservation_status` bywa też numerem
// statusu z bazy; liczba nie pasuje do wzorca, więc taka rezerwacja nie jest uznana za anulowaną
// (bezpieczny kierunek: pokazana, nie ukryta).
export function isCancelledReservation(reservation) {
  if (!reservation) return false;
  return isCancelledStatusName(reservation.reservation_status_name || reservation.reservation_status);
}

export const withoutCancelled = (list) => (Array.isArray(list) ? list.filter((r) => !isCancelledReservation(r)) : []);
